// FIFO себестойността на (продукт, склад) за разнасянето: партидите на склада
// от най-старата, колкото стигат за количеството. Изписването при разнасяне е
// ВИНАГИ FIFO (изборът на партида е премахнат). Сумата се пише обратно в
// състоянието (`onCost`) — от там идват Нето/Бруто във футъра.
import { useEffect, useMemo } from "react";
import { useLots } from "../../../../hooks/useInventory";

// warehouseId=null (станцията няма склад) → без заявка за партиди.
export const useWarehouseCost = (
  productId: number,
  warehouseId: number | null,
  need: number,
  onCost: (value: number | null) => void,
) => {
  const { data: lots = [] } = useLots(warehouseId, productId);
  const unitPrice = useMemo<number | null>(() => {
    if (need <= 0) return lots.length ? lots[0].unitPrice : null;
    let remaining = need;
    let cost = 0;
    let consumed = 0;
    for (const lot of lots) {
      if (remaining <= 0) break;
      const take = Math.min(lot.remaining, remaining);
      cost += take * lot.unitPrice;
      consumed += take;
      remaining -= take;
    }
    if (consumed <= 0) return lots.length ? lots[0].unitPrice : null;
    return cost / consumed;
  }, [need, lots]);
  const sum = need > 0 && unitPrice != null ? need * unitPrice : null;
  useEffect(() => {
    onCost(sum);
    return () => onCost(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sum]);
  return { sum };
};
